/**
 * Centralized configuration for the External Supabase project.
 *
 * The External Supabase project is the shared backend that hosts bookings,
 * customers, notifications, etc. It is distinct from the Lovable Cloud
 * project used by Edge Functions (see `src/integrations/supabase/client.ts`).
 *
 * Values are read from Vite env vars at build time:
 *   - VITE_EXTERNAL_SUPABASE_URL
 *   - VITE_EXTERNAL_SUPABASE_ANON_KEY
 *
 * A missing value throws immediately so mis-configured builds fail loudly
 * instead of silently constructing an unusable Supabase client.
 */

const url = import.meta.env.VITE_EXTERNAL_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_EXTERNAL_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  const missing = [
    !url && 'VITE_EXTERNAL_SUPABASE_URL',
    !anonKey && 'VITE_EXTERNAL_SUPABASE_ANON_KEY',
  ]
    .filter(Boolean)
    .join(', ');
  throw new Error(
    `[externalSupabase] Missing required environment variable(s): ${missing}. ` +
      `Add them to .env before building the app.`,
  );
}

export const EXTERNAL_SUPABASE_URL: string = url;
export const EXTERNAL_SUPABASE_ANON_KEY: string = anonKey;
